module.exports = __webpack_public_path__ + "img/地图.399bf6bf.gif";